/**
 * Ticket WK1: Datei im Browser lesen. Die Datei wird nie hochgeladen – nur die
 * geprüften Zeilen gehen später an den Server. Gelesen wird als Zellgitter,
 * weil die Vorlage in der ersten Zeile Gruppenüberschriften trägt und erst die
 * zweite Zeile die Spalten nennt.
 */

import { parseCsv, detectDelimiter } from "@/lib/contacts-import";

export const MUNICIPALITY_ACCEPT = ".xlsx,.xls,.csv,.txt";

export async function readMunicipalityFile(file: File): Promise<string[][]> {
  const name = file.name.toLowerCase();
  if (name.endsWith(".xlsx") || name.endsWith(".xls")) return readExcel(file);
  return readCsvMatrix(await file.text());
}

export function readCsvMatrix(text: string): string[][] {
  const delimiter = detectDelimiter(text);
  // `parseCsv` liefert Kopfzeile plus Objekte; für das Gitter nutzen wir die
  // Kopfzeile als erste Zeile und danach die Werte in Spaltenreihenfolge.
  const sheet = parseCsv(text);
  const matrix: string[][] = [sheet.headers];
  for (const row of sheet.rows) matrix.push(sheet.headers.map((h) => row[h] ?? ""));
  void delimiter;
  return matrix;
}

async function readExcel(file: File): Promise<string[][]> {
  const XLSX = await import("xlsx");
  const wb = XLSX.read(await file.arrayBuffer(), { type: "array", cellDates: false, raw: false });
  const first = wb.SheetNames[0];
  if (!first) return [];
  const matrix = XLSX.utils.sheet_to_json<string[]>(wb.Sheets[first], {
    header: 1,
    raw: false,
    defval: "",
    blankrows: false,
  });
  return matrix.map((row) => (row ?? []).map((cell) => String(cell ?? "")));
}
